export class ContractorAdapter {
  convertResponse<T>(item: any): T[] {
    return item.Data.Table;
  }
  convertToDataResponse<T>(item: any): T[] {
    return item.Data;
  }
}
